<template>
  <div id="app" :class="klase">
    <!-- <img src="./assets/logo.png"> -->
  <transition name="slide-fade" mode="out-in"><router-view></router-view></transition>
  </div>
</template>

<script>

import router from '@/router'

export default {
  name: 'App',
  data() {
    return {
      klase: ""
    }
  },
  mounted () {
    sessionStorage.removeItem("isolirNotif");

    var color = this.$route.query.color;
    if (color == "red") {
      this.klase = "red";
    } else if (color == "bluedark") {
      this.klase = "bluedark";
    } else if (color == "bluesea") {
      this.klase = "bluesea";
    } else if (color == "blueyoung") {
      this.klase = "blueyoung";
    } else if (color == "green") {
      this.klase = "green";
    } else if (color == "black") {
      this.klase = "black";
    } else if (color == "purple") {
      this.klase = "purple";
    } else if (color == "orange") {
      this.klase = "orange";
    } else if (color == "graybg") {
      this.klase = "graybg";
    } else if (color == "pink") {
      this.klase = "pink";
    } else {
      this.klase = "";
    }
    console.log(color); 
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue